export default {
    respectDNT: false,
    productionOnly: true,
};
